import r from "../../managers/braze-instance.js";
import { destroyFeed, showFeed } from "../index.js";
export function toggleFeed(e, o, n) {
  r.rr() &&
    (document.querySelectorAll(".ab-feed").length > 0
      ? destroyFeed()
      : showFeed(e, o, n));
}
